<div class="main">
  <h2>Tipo de firma</h2>
  <form [formGroup]="formularioDocumentoService.formularioDocumento">
    <app-configuracion-firmas-tipo-firmantes *ngFor="let tipo of mostrarFirmantes" [firmante]="tipo" (firmanteSeleccionado)="seleccionarFirmante($event)"></app-configuracion-firmas-tipo-firmantes>
  </form>
</div>

